{
"catalog": {
" company has been added": " se ha a\u00f1adido la empresa",
" day. Renew now to continue enjoying uninterrupted access.": " d\u00eda. Renueve ahora para seguir disfrutando de acceso ininterrumpido.",
" days. Renew now to continue enjoying uninterrupted access.": " d\u00edas. Renueve ahora para seguir disfrutando de acceso ininterrumpido.",
"(\u00d8re/kWh)": "(\u00d8re/kWh)",
"0.00": "0.00",
": The new company has been added": ": Se ha a\u00f1adido la nueva empresa",
"A code of reference ( Who referred a company)": "Un c\u00f3digo de referencia ( Qui\u00e9n remiti\u00f3 una empresa)",
"A link has been sent to your email address to reset password": "Se ha enviado un enlace a su direcci\u00f3n de correo electr\u00f3nico para restablecer la contrase\u00f1a",
"A link has been sent to your email address to reset password.": "Se ha enviado un enlace a su direcci\u00f3n de correo electr\u00f3nico para restablecer la contrase\u00f1a.",
"A newer version of this application is available. The update will begin automatically in 20 seconds.": "Hay disponible una versi\u00f3n m\u00e1s reciente de esta aplicaci\u00f3n. La actualizaci\u00f3n comenzar\u00e1 autom\u00e1ticamente en 20 segundos.",
"A suspicious activity was detected. For security reasons, you must log in again": "Se ha detectado una actividad sospechosa. Por razones de seguridad, debe iniciar sesi\u00f3n de nuevo",
"API Documentation": "Documentaci\u00f3n de la API",
"API Key": "Clave API",
"API key": "Clave API",
"Access from partner website": "Acceso desde el sitio web asociado",
"Access given": "Acceso concedido",
"Access is Required!": "Acceso obligatorio !",
"Access period": "Periodo de acceso",
"Account Setup": "Configuraci\u00f3n de cuenta",
"Account creation code": "C\u00f3digo de creaci\u00f3n de cuenta",
"Actions": "Acciones",
"Active": "Activo",
"Active Users": "Usuarios activos",
"Active Users List": "Lista de usuarios activos",
"Add": "A\u00f1adir",
"Add Contract": "Agregar contrato",
"Add Corporate Group": "A\u00f1adir grupo corporativo",
"Add Customer": "Agregar cliente",
"Add Document": "A\u00f1adir documento",
"Add Historical Data Limit": "A\u00f1adir l\u00edmite de datos hist\u00f3ricos",
"Add New Corporate Group": "A\u00f1adir nuevo grupo corporativo",
"Add New Feature": "Agregar caracter\u00edstica nueva",
"Add New Module": "Agregar Nuevo M\u00f3dulo",
"Add New Partner": "A\u00f1adir Nuevo Socio",
"Add New Subscription": "A\u00f1adir nueva suscripci\u00f3n",
"Add New User": "A\u00f1adir nuevo usuario",
"Add Partner": "A\u00f1adir socio",
"Add User": "A\u00f1adir usuario",
"Add a new role": "A\u00f1ade un nuevo rol",
"Add company": "Agregar empresa",
"Add contract": "A\u00f1adir controto",
"Add feature": "A\u00f1adir caracter\u00edstica",
"Add permission": "A\u00f1adir permiso",
"Add role": "A\u00f1adir rol",
"Add subscription plan": "Agregar plan de suscripci\u00f3n",
"Address": "Direcci\u00f3n",
"Aggregated": "Agregado",
"Aggregation": "Agregaci\u00f3n",
"Alias": "Alias",
"All": "Todo",
"All Documents": "Todos los documentos",
"All Partners": "Todas los Socios",
"All Users": "Todos los usuarios",
"All kWh": "Todos los kWh",
"All notifications deleted successfully": "Todas las notificaciones se han eliminado correctamente.",
"All notifications marked as read": "Todas las notificaciones marcadas como le\u00eddas",
"Alpha numeric and dash only": "S\u00f3lo alfanum\u00e9rico y gui\u00f3n",
"Already have an account?": "\u00bfYa tienes una cuenta?",
"Amount of money for consumption": "Cantidad de dinero para consumo",
"An error occurred while deleting the document": "Se ha producido un error al eliminar el documento.",
"An error occurred while the system was generating the report. Please try again. You can contact support If this continues.": "Se ha producido un error mientras el sistema generaba el informe. Por favor, int\u00e9ntelo de nuevo. Si el error persiste, p\u00f3ngase en contacto con el servicio de asistencia.",
"An unexpected error occurred. It has been logged, and we are working on a resolution.": "Se ha producido un error inesperado. Se ha registrado y estamos trabajando para solucionarlo.",
"Annual CO\u2082e (Kg)": "CO\u2082e anual (Kg)",
"Annual Statement": "Declaraci\u00f3n anual",
"Annual energy consumption (kWh)": "Consumo anual de energ\u00eda (kWh)",
"App": "App",
"App URL": "URL de la aplicaci\u00f3n",
"Apr": "Abr",
"Apr: Checking": "Apr: Comprobaci\u00f3n de",
"Apr: Get": "Apr: Visite",
"Apr: Update": "Apr: Actualizaci\u00f3n",
"April": "Abril",
"Are you sure you want to delete this notification ? ": "\u00bfEst\u00e1s seguro de que deseas eliminar esta notificaci\u00f3n? ",
"Are you sure you want to delete?": "Est\u00e1s seguro de que deseas eliminar?",
"Attach Company with User": "Adjuntar empresa con usuario",
"Aug": "Ago",
"Aug: Checking": "Ago: Comprobaci\u00f3n de",
"Aug: Get": "Ago: Visite",
"Aug: Update": "Ago: Actualizaci\u00f3n",
"August": "Agosto",
"Authority Processing": "Tramitaci\u00f3n de autorizaciones",
"Authorization": "Autorizaci\u00f3n",
"Availability Payment": "Disponibilidad Pago",
"Availability Rate": "Tasa de disponibilidad",
"Back": "Volver",
"Back to": "Volver a",
"Back to Documents": "Volver a Documentos",
"Basic Information": "Informaci\u00f3n b\u00e1sica",
"Before getting started, could you verify your email address by ": "Antes de empezar, \u00bfpodr\u00eda verificar su direcci\u00f3n de correo electr\u00f3nico? ",
"Blocked": "Bloqueado",
"Building": "Edificio",
"Building address": "Direcci\u00f3n del edificio",
"Building is required": "Es necesario construir",
"But you still need to know more.": "Pero a\u00fan necesitas saber m\u00e1s.",
"CAPTCHA verification failed. Please try again.": "La verificaci\u00f3n CAPTCHA ha fallado. Int\u00e9ntalo de nuevo.",
"CCPA Privacy Rights (Do Not Sell My Personal Information)": "Derechos de privacidad CCPA (No vender mi informaci\u00f3n personal)",
"CO\u2082_per_m2": "CO\u2082_por_m2",
"CO\u2082e": "CO\u2082e",
"CO\u2082e (Kg)": "CO\u2082e (Kg)",
"CVR": "N\u00famero de la empresa",
"Cached": "En cach\u00e9",
"Cancel": "Cancelar",
"Carbon Emissions (Kg CO\u2082e)": "Emisiones de carbono (kg CO\u2082e)",
"Carbon Footprint (g CO\u2082e/kWh)": "Huella de carbono (g CO\u2082e/kWh)",
"Carbon dioxide Consumption": "Di\u00f3xido de carbono Consumo",
"Cashed Statement - Under Development": "Declaraci\u00f3n cobrada - En desarrollo",
"Central business Register number": "N\u00famero del Registro Mercantil Central",
"Change Password": "Cambiar Contrase\u00f1a",
"Change password": "Cambiar contrase\u00f1a",
"Checking Cache": "Comprobaci\u00f3n de la cach\u00e9",
"Child Company": "Empresa filial",
"Child company and above level access": "Empresa filial y acceso de nivel superior",
"City": "Ciudad",
"Clear above cache": "Borrar la cach\u00e9",
"Clear all cache": "Vaciar cach\u00e9",
"Clear browser memory / Page reload": "Borrar la memoria del navegador / Recargar la p\u00e1gina",
"Click to copy": "Haz clic para copiar",
"Click to upload or drag and drop": "Haga clic para cargar o arrastre y suelte",
"Climate": "Clim\u00e1tico",
"Climate report": "Informe sobre el clima",
"Close": "Cerrar",
"Co2 Certificates": "Certificados de CO2",
"Code": "C\u00f3digo",
"Coming Soon": "Pr\u00f3ximamente",
"Commission Price": "Precio de la Comisi\u00f3n",
"Commission Share": "Comisi\u00f3n compartida",
"Companies": "Empresas",
"Companies for ": "Empresas para ",
"Companies for the corporate group: ": "Empresas del grupo empresarial: ",
"Company": "Empresa",
"Company Authenticity number": "N\u00famero de autenticidad de la empresa",
"Company Name": "Nombre de la empresa",
"Company No.": "N\u00ba de empresa.",
"Company Number": "N\u00famero de la empresa",
"Company Roles": "Funciones de la empresa",
"Company Users for ": "Usuarios de la empresa para ",
"Company name": "Nombre de la empresa",
"Company website": "Web de la empresa",
"Compensation": "Compensaci\u00f3n",
"Confirm Email Address": "Confirmar correo electr\u00f3nico",
"Confirm Password": "Confirmar contrase\u00f1a",
"Confirm Password is required": "Se requiere confirmaci\u00f3n de contrase\u00f1a",
"Confirm password does not match.": "Confirmar contrase\u00f1a no coincide.",
"Confirmation": "Confirmaci\u00f3n",
"Congratulations, you\u2019ve chosen the best energy spending platform": "Enhorabuena, has elegido la mejor plataforma de gasto energ\u00e9tico",
"Consent": "Consentimiento",
"Consumption": "Consumo",
"Consumption (kWh)": "Consumo (kWh)",
"Consumption and CO\u2082e": "Consumo y CO\u2082e",
"Consumption is kWh": "Consumo en kWh",
"Consumption measured in kWh": "Consumo medido en kWh",
"Contact Name": "Nombre de contacto",
"Contact Phone": "Tel\u00e9fono de contacto",
"Continue": "Continuar",
"Contract list": "Lista de contratos",
"Contracts": "Contratos",
"Conversion Rate": "Tasa de Conversi\u00f3n",
"Conversion Rate for CO\u2082e": "\u00cdndice de conversi\u00f3n del CO\u2082e",
"Conversion rate in g CO\u2082e/kWh": "\u00cdndice de conversi\u00f3n en g CO\u2082e/kWh",
"Copied to clipboard": "Copiado al portapapeles",
"Corporate Group": "Grupo empresarial",
"Corporate Groups": "Grupos corporativos",
"Corporate Groups for the partner ": "Grupos corporativos para el socio ",
"Corporate group and above level access": "Acceso a nivel de grupo corporativo y superior",
"Cost": "Costo",
"Cost (DKK)": "Coste (DKK)",
"Cost in DKK": "Coste en DKK",
"Country": "Pa\u00eds",
"Country code": "C\u00f3digo del pa\u00eds",
"Country, Timezone and Corporate Group is Required!": "\u00a1Se requiere indicar el pa\u00eds, la zona horaria y el grupo corporativo!",
"Create Historical Data Limit": "Crear l\u00edmite de datos hist\u00f3ricos",
"Create New Contract": "Crear un nuevo contrato",
"Create a new password": "Crear una nueva contrase\u00f1a",
"Create or get an API key to access your data.": "Cree u obtenga una clave API para acceder a sus datos.",
"Created At": "Creado en",
"Created By": "Creado Por",
"Currency": "Moneda",
"Currency is required": "Moneda es obligatoria",
"Current Password": "Contrase\u00f1a Actual",
"Current month only": "S\u00f3lo el mes en curso",
"Current year only": "S\u00f3lo a\u00f1o en curso",
"Customer": "Cliente",
"DKK": "DKK",
"Daily": "Diariamente",
"Danish": "Dan\u00e9s",
"Data Delivered By": "Datos facilitados por",
"Data granularity. PT1H = every 1 hour, PT15M = every 15 minutes": "Granularidad de los datos. PT1H = cada 1 hora, PT15M = cada 15 minutos",
"Data is currently being loaded. Please hold on a moment.": "Se est\u00e1n cargando los datos. Por favor, espere un momento.",
"Data validation - consumption": "Validaci\u00f3n de datos - consumo",
"DataHub": "DataHub",
"Date": "Fecha",
"Date when the access is given": "Fecha en que se concede el acceso",
"Day": "D\u00eda",
"Day Report - Under development": "Informe diario - En desarrollo",
"Days": "D\u00edas",
"Dear {{user_full_name}}": "Querido {{user_full_name}}",
"Dec": "Dic",
"Dec: Checking": "Dec: Comprobaci\u00f3n",
"Dec: Get": "Dic: Obtener",
"Dec: Update": "Dic: Actualizaci\u00f3n",
"December": "Diciembre",
"Delete": "Borrar",
"Delete API Key": "Eliminar clave API",
"Delete All Notifications": "Eliminar todas las notificaciones",
"Deleted": "Eliminado",
"Description": "Descripci\u00f3n",
"Developer": "Desarrollador",
"Did you forget your password? Create a new one by clicking the button below.": "\u00bfHas olvidado tu contrase\u00f1a? Cree una nueva haciendo clic en el bot\u00f3n de abajo.",
"Did you get this email by mistake? If so no worries - you can just ignore it.": "\u00bfHa recibido este mensaje por error? Si es as\u00ed, no se preocupe: puede ignorarlo.",
"Difference": "Diferencia",
"Discount Net Tariff": "Tarifa neta de descuento",
"Discount Subscription": "Suscripci\u00f3n con descuento",
"Distribution": "Distribuci\u00f3n",
"District Heating": "Calefacci\u00f3n urbana",
"Do you know?": "\u00bfSabes?",
"Do you want to delete the document?": "\u00bfDesea eliminar el documento?",
"Do you want to delete the historical data limit?": "\u00bfDesea eliminar el l\u00edmite de datos hist\u00f3ricos?",
"Do you want to delete the notification?": "\u00bfDesea eliminar la notificaci\u00f3n?",
"Do you want to unlink the company?": "\u00bfQuiere desvincular la empresa?",
"Do you want to unlink the user?": "\u00bfQuieres desvincular al usuario?",
"Document Details": "Detalles del Documento",
"Document For": "Documento para",
"Document Preview": "Vista previa del documento",
"Document Type": "Tipo de Documento",
"Document Uploading Failed": "Error en la carga de documentos",
"Document deleted successfully": "Documento eliminado correctamente",
"Document list": "Liste de documentos",
"Document not found": "Documento no encontrado",
"Document updated successfully": "Documento actualizado correctamente",
"Document uploaded successfully": "Documento cargado correctamente",
"Documents": "Documentos",
"Don't Have An Account Yet?": "\u00bfA\u00fan no tiene una cuenta?",
"Download": "Descargar",
"Download Climate Report": "Descargar el informe sobre el clima",
"Download Cost Report": "Descargar el informe de costes",
"Download Document": "Descargar documento",
"Download Energy Report": "Descargar el informe sobre la energ\u00eda",
"Download For App": "Descargar la aplicaci\u00f3n",
"Download For WWW": "Descargar para WWW",
"Download Sport Price Report": "Descargar el informe sobre precios del deporte",
"Download report": "Descargar reporte",
"Drag and drop files here or click": "Arrastra y suelta los archivos aqu\u00ed o haz clic.",
"Drop the file here or": "Suelte el archivo aqu\u00ed o",
"Dutch": "Holand\u00e9s",
"EPAD": "EPAD",
"EPAD Price": "Precio EPAD",
"EPAD Share": "Acci\u00f3n EPAD",
"EPAD Type": "Tipo EPAD",
"EPAD kWh": "EPAD kWh",
"Edit": "Editar",
"Edit Contract": "Editar Contrato",
"Edit Corporate Group": "Editar grupo corporativo",
"Edit Document Details": "Editar detalles del documento",
"Edit Feature": "Editar caracter\u00edstica",
"Edit Historical Data Limit": "Editar l\u00edmite de datos hist\u00f3ricos",
"Edit Module": "Editar m\u00f3dulo",
"Edit Partner": "Editar Asociado",
"Edit Role": "Editar Rol",
"Edit Subscription": "Editar suscripci\u00f3n",
"Edit User": "Editar Usuario",
"Edit User Company": "Editar usuario Empresa",
"Effect Payment": "Pago efectivo",
"Effortless energy insights at your fingertips": "Informaci\u00f3n energ\u00e9tica sin esfuerzo al alcance de tu mano",
"Ekskl. moms": "Sin IVA",
"Electricity": "Electricidad",
"Electricity Charge": "Electricidad",
"Electricity consumption": "Consumo de electricidad",
"Electricity measured in kWh": "Electricidad medida en kWh",
"Email": "Email",
"Email Not Verified": "correo no verificado",
"Email Sent ": "Correo electr\u00f3nico enviado ",
"Email address": "Direcci\u00f3n de correo electr\u00f3nico",
"Email is required.": "Correo electr\u00f3nico requerido.",
"End": "Fin",
"End Date": "Fecha de finalizaci\u00f3n",
"Energy": "Energ\u00eda",
"Energy Consumption (kWh)": "Consumo de energ\u00eda (kWh)",
"Energy Contract": "Contrato de energ\u00eda",
"Energy Type": "Tipo de energ\u00eda",
"Energy report": "Informe energ\u00e9tico",
"Energy type is required": "Se requiere el tipo de energ\u00eda",
"English": "Ingl\u00e9s",
"Enter description": "Descripci\u00f3n",
"Enter email": "Introduzca Email",
"Enter email address": "Introduce direcci\u00f3n de email",
"Enter email address to continue.": "Introduzca su direcci\u00f3n de correo electr\u00f3nico para continuar.",
"Enter full name": "Nombre completo",
"Enter name": "Introduzca nombre",
"Enter password": "Introducir la contrase\u00f1a",
"Enter password again": "Escribe de nuevo tu contrase\u00f1a",
"Enter your new password to reset": "Introduzca su nueva contrase\u00f1a para restablecer",
"Error loading image:": "Error al cargar la imagen:",
"Error: Something went wrong!": "Error: \u00a1Algo ha ido mal!",
"Error: Something went wrong! ": "Error: \u00a1Algo ha ido mal! ",
"Excel Reports": "Informes Excel",
"Excel Update": "Actualizaci\u00f3n de Excel",
"Expire At": "Caduca a las",
"Export": "Exportar",
"Export to Excel": "Exportar a Excel",
"Fabeke": "Fabeke",
"Fabeke Data": "Datos de Fabeke",
"Fabeke follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.": "Fabeke sigue un procedimiento est\u00e1ndar de utilizaci\u00f3n de archivos de registro. Estos archivos registran a los visitantes cuando visitan los sitios web. Todas las empresas de alojamiento lo hacen y forma parte de los an\u00e1lisis de los servicios de alojamiento. La informaci\u00f3n recogida por los archivos de registro incluye direcciones de protocolo de Internet (IP), tipo de navegador, proveedor de servicios de Internet (ISP), fecha y hora, p\u00e1ginas de referencia/salida y, posiblemente, el n\u00famero de clics. Estos datos no est\u00e1n vinculados a ninguna informaci\u00f3n que permita la identificaci\u00f3n personal. El prop\u00f3sito de la informaci\u00f3n es analizar tendencias, administrar el sitio, rastrear los movimientos de los usuarios en el sitio web y recopilar informaci\u00f3n demogr\u00e1fica.",
"Fabeke's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.": "La Pol\u00edtica de Privacidad de Fabeke no se aplica a otros anunciantes o sitios web. Por lo tanto, le aconsejamos que consulte las respectivas Pol\u00edticas de Privacidad de estos servidores de anuncios de terceros para obtener informaci\u00f3n m\u00e1s detallada. Puede incluir sus pr\u00e1cticas e instrucciones sobre c\u00f3mo optar por no participar en ciertas opciones.",
"Failed to delete document": "No se ha podido eliminar el documento.",
"Failed to load document preview. Please try downloading the document.": "No se ha podido cargar la vista previa del documento. Intente descargar el documento.",
"Failed to unlink. ": "Fallo al desvincular. ",
"Feature": "Destacado",
"Feature Name": "Nombre destacado",
"Feature key, Alpha numeric and dash only": "Tecla de funci\u00f3n, s\u00f3lo alfanum\u00e9rica y gui\u00f3n",
"Features": "Caracter\u00edsticas",
"Features for ": "Caracter\u00edsticas ",
"Feb": "Feb",
"Feb: Checking": "Feb: Comprobaci\u00f3n de",
"Feb: Get": "Feb: Visite",
"Feb: Update": "Feb: Actualizaci\u00f3n",
"February": "Febrero",
"Feel free to reach out to Customer Service. They are around 24/7 to help you.": "No dude en ponerse en contacto con el Servicio de Atenci\u00f3n al Cliente. Est\u00e1n disponibles 24 horas al d\u00eda, 7 d\u00edas a la semana.",
"File Name": "Nombre del archivo",
"File type not supported": "Tipo de archivo no compatible",
"Fixed": "Fijo",
"Fixed Price": "Precio fijo",
"Fixed price": "Precio fijo",
"Fixed price ex epad": "Precio fijo ex epad",
"Fixed price ex epad and profile": "Precio fijo ex epad y perfil",
"Fixed price ex profile": "Precio fijo ex perfil",
"Fixed profile ex spot": "Perfil fijo ex spot",
"Forgot Password": "\u00bfSe te olvid\u00f3 tu contrase\u00f1a?",
"Forgot Your Password?": "\u00bfOlvidaste tu contrase\u00f1a?",
"Forgot your password?": "\u00bfOlvidaste tu contrase\u00f1a?",
"French": "Franc\u00e9s",
"From": "Desde",
"From date is required": "Se requiere la fecha Desde",
"Full Name": "Nombre completo",
"Full Year": "A\u00f1o completo",
"Gain control of your energy spending": "Controle su gasto energ\u00e9tico",
"Gas": "Gas",
"Generate API Key": "Generar clave API",
"Generate Climate Report": "Generar informe clim\u00e1tico",
"Generate Cost Report": "Generar informe de costes",
"Generate Email": "Generar correo electr\u00f3nico",
"Generate Energy Report": "Generar informe energ\u00e9tico",
"Generate Sport Price Report": "Generar informe de precios deportivos",
"Generating Excel file": "Generaci\u00f3n de archivos Excel",
"German": "Alem\u00e1n",
"Get Full Visibility Over Your Energy Spending With Less Manual Work": "Obtenga una visibilidad total de su gasto energ\u00e9tico con menos trabajo manual",
"Getting Data": "Obtenci\u00f3n de datos",
"Go to App": "Ir a la App",
"Green Certificates": "Certificados verdes",
"Green Electricity": "Electricidad verde",
"Grid company": "Empresa de red",
"Heating": "Calefaccion",
"Historical Data": "Datos hist\u00f3ricos",
"Historical Data Limits": "L\u00edmites de datos hist\u00f3ricos",
"Hour": "Hora",
"Hour Report - Under development": "Informe por hora - En desarrollo",
"Hourly": "Cada hora",
"Hours": "Horas",
"House No.": "Casa No.",
"How many buildings company have": "Cu\u00e1ntos edificios tiene la empresa",
"How many meters company have": "Cu\u00e1ntos contadores tiene la empresa",
"I agree with": "Estoy de acuerdo con los",
"ID": "ID",
"If the data is heavy, it may still be loading.": "Si los datos son pesados, es posible que a\u00fan se est\u00e9n cargando.",
"If you want to set no limit, add 999 in the numeric field. If you want to give no access, you can handle that in the subscription plan features. However, to implement this historical data limit, you must attach it to the subscription plan.": "Si no desea establecer ning\u00fan l\u00edmite, a\u00f1ada 999 en el campo num\u00e9rico. Si no desea conceder acceso, puede gestionarlo en las caracter\u00edsticas del plan de suscripci\u00f3n. Sin embargo, para implementar este l\u00edmite de datos hist\u00f3ricos, debe adjuntarlo al plan de suscripci\u00f3n.",
"InActive": "Inactivo",
"Inkl. Moms": "Incluidas las madres",
"Installation Numbers": "N\u00fameros de instalaci\u00f3n",
"Installation number": "N\u00famero de instalaci\u00f3n",
"Installation number is required": "Se requiere el n\u00famero de instalaci\u00f3n",
"Internet connection restored": "Conexi\u00f3n a Internet restablecida",
"Interval": "Intervalo",
"Invite User": "Invitar usuario",
"Invoice": "Factura",
"Invoices": "Facturas",
"It appears that no company is associated with your account.": "Parece que ninguna empresa est\u00e1 asociada a su cuenta.",
"It will download a zip file containing the PO and POT files. PO file will have the existing translations, and the POT file will have the latest text that requires translation. We can use the Poedit software to import the POT text into the PO file and translate it.": "Se descargar\u00e1 un archivo zip que contiene los archivos PO y POT. El archivo PO tendr\u00e1 las traducciones existentes, y el archivo POT tendr\u00e1 el texto m\u00e1s reciente que requiere traducci\u00f3n. Podemos utilizar el software Poedit para importar el texto POT al archivo PO y traducirlo.",
"Item": "Art\u00edculo",
"Items": "Art\u00edculos",
"Jan": "Ene",
"Jan: Checking": "Jan: Comprobaci\u00f3n",
"Jan: Get": "Jan: Get",
"Jan: Update": "Jan: Actualizaci\u00f3n",
"January": "Enero",
"Japanese": "Japon\u00e9s",
"Jul": "Jul",
"Jul: Checking": "Jul: Comprobaci\u00f3n de",
"Jul: Get": "Jul: Visite",
"Jul: Update": "Jul: Actualizaci\u00f3n",
"July": "Julio",
"Jun": "Jun",
"Jun: Checking": "Jun: Comprobaci\u00f3n de",
"Jun: Get": "Jun: Visite",
"Jun: Update": "Jun: Actualizaci\u00f3n",
"June": "Junio",
"Key": "Clave",
"Key, Alpha numeric and dash only": "Tecla, s\u00f3lo alfanum\u00e9rico y gui\u00f3n",
"Kg of CO\u2082e": "Kg de CO\u2082e",
"Kilogram": "Kilogramo",
"LNG": "LNG",
"Language": "Idioma",
"Languages": "Idiomas",
"Last Login": "\u00daltimo acceso",
"Last Run": "\u00daltima ejecuci\u00f3n",
"Last date": "\u00daltima fecha",
"Last seen": "Conectado ultima vez",
"Like any other website, Fabeke uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.": "Como cualquier otro sitio web, Fabeke utiliza \"cookies\". Estas cookies se utilizan para almacenar informaci\u00f3n, incluidas las preferencias de los visitantes y las p\u00e1ginas del sitio web a las que el visitante accedi\u00f3 o visit\u00f3. La informaci\u00f3n se utiliza para optimizar la experiencia de los usuarios personalizando el contenido de nuestra p\u00e1gina web en funci\u00f3n del tipo de navegador de los visitantes y/u otra informaci\u00f3n.",
"Link": "Enlace",
"Link User": "Activar acceso",
"Link company": "Enlace empresa",
"Link user": "Enlace usuario",
"List View": "Vista de lista",
"List as": "Enumerar como",
"Loading": "Cargando",
"Loading security verification...": "Cargando verificaci\u00f3n de seguridad...",
"Loading...": "Cargando...",
"Location": "Ubicaci\u00f3n",
"Location and above level access": "Ubicaci\u00f3n y acceso a nivel superior",
"Login": "Iniciar sesi\u00f3n",
"Login as": "Iniciar sesi\u00f3n como",
"Login code": "C\u00f3digo de acceso",
"Login failed! Please try again": "Error al iniciar sesi\u00f3n Por favor, int\u00e9ntelo de nuevo",
"Login successful. Redirecting.": "Inicio de sesi\u00f3n correcto. Redirigiendo.",
"Login with your new password right away.": "Inicie sesi\u00f3n con su nueva contrase\u00f1a inmediatamente.",
"Main Price Type": "Tipo de precio principal",
"Mandarin": "Mandar\u00edn",
"Mar": "Mar",
"Mar: Checking": "Mar: Comprobaci\u00f3n de",
"Mar: Get": "Mar: Visite",
"Mar: Update": "Mar: Actualizaci\u00f3n",
"March": "Marzo",
"Mark As Read": "Marcar Como Le\u00eddo",
"Markup": "Margen",
"Markup Price": "Precio de recargo",
"Markup Share": "Cuota de marcado",
"Max size supported 20MB": "Tama\u00f1o m\u00e1ximo admitido: 20 MB.",
"Maximum 50 symbols": "M\u00e1ximo 50 s\u00edmbolos",
"May": "Mayo",
"May: Checking": "Mayo: Comprobaci\u00f3n de",
"May: Get": "Mayo: Visite",
"May: Update": "Mayo: Actualizaci\u00f3n",
"Message": "Mensaje",
"Meter": "Medidor",
"Meter No": "Contador No",
"Meter and above level access": "Acceso a nivel del medidor y superior",
"Meter number": "N\u00famero de contador",
"Meter reading end date": "Fecha final de lectura del contador",
"Meter reading start date": "Fecha de inicio de la lectura del contador",
"Minimum 3 symbols": "M\u00ednimo 3 s\u00edmbolos",
"Minimum Fee": "Hnorario m\u00ednima",
"Modals": "Modalidades",
"Module": "M\u00f3dulo",
"Module code, Alpha numeric and dash only": "C\u00f3digo del m\u00f3dulo, s\u00f3lo alfanum\u00e9rico y gui\u00f3n",
"Module name": "Nombre del m\u00f3dulo",
"Moms": "Mam\u00e1s",
"Month": "Mes",
"Month Columns: Downloading": "Columnas del mes: Descargar",
"Month Columns: Processing": "Columnas mensuales: Tratamiento",
"Month Data: Downloading": "Datos del mes: Descargar",
"Month Data: Processing": "Datos del mes: Tratamiento",
"Month Report - Under development": "Informe mensual - En desarrollo",
"Monthly": "Mensual",
"Monthly Statement": "Declaraci\u00f3n mensual",
"Months": "Meses",
"Must be a valid email": "Por favor, introduce una direcci\u00f3n de correo v\u00e1lida",
"My Account": "Mi cuenta",
"My Companies": "Mis empresas",
"My Profile": "Mi Perfil",
"Name": "Nombre",
"Name is required.": "Nombre requerido.",
"Natural Gas": "Gas natural",
"Net": "Neto",
"Net Tariff": "Tarifa neta",
"Never Login": "No iniciar sesi\u00f3n",
"New": "Nuevo",
"New Password": "Nueva contrase\u00f1a",
"New Password is required": "Se requiere una nueva contrase\u00f1a.",
"No": "No",
"No Company": "Ninguna empresa",
"No Documents Found": "No se encontraron documentos.",
"No Historical Data Limit": "Sin l\u00edmite de datos hist\u00f3ricos",
"No Limit": "S\u00edn l\u00edmite",
"No Partner": "Empresa",
"No Results Found!": "\u00a1No se han encontrado resultados!",
"No Rows": "Sin filas",
"No data found": "No se han encontrado datos",
"No document available for preview": "No hay ning\u00fan documento disponible para previsualizar.",
"No internet connection. Please check your network.": "No hay conexi\u00f3n a Internet. Comprueba tu red.",
"No option available": "Ninguna opci\u00f3n disponible",
"No use of Fabeke's logo or other artwork will be allowed for linking absent a trademark license agreement.": "No se permitir\u00e1 el uso del logotipo de Fabeke u otras ilustraciones para establecer enlaces sin un acuerdo de licencia de marca.",
"Norwegian": "Noruego",
"Not Applicable": "No es Aplicable",
"Not Cached": "No almacenado en cach\u00e9",
"Not Found": "No encontrado",
"Notes": "Notas",
"Notification has been deleted": "Se ha eliminado la notificaci\u00f3n",
"Notification marked as read": "Notificaci\u00f3n marcada como le\u00edda",
"Notifications": "Notificaciones",
"Nov": "Nov",
"Nov: Checking": "Nov: Comprobaci\u00f3n de",
"Nov: Get": "Nov: Visite",
"Nov: Update": "Nov: Actualizaci\u00f3n",
"November": "Noviembre",
"Oct": "Oct",
"Oct: Checking": "Oct: Comprobaci\u00f3n de",
"Oct: Get": "Oct: Visite",
"Oct: Update": "Oct: Actualizaci\u00f3n",
"October": "Octubre",
"Official address of meter (not including location information)": "Direcci\u00f3n oficial del contador (sin incluir informaci\u00f3n sobre la ubicaci\u00f3n)",
"Often the number on company's bill": "A menudo el n\u00famero de la factura de la empresa",
"Oil": "Aceite",
"One Month Energy Consumption (kWh)": "Consumo mensual de energ\u00eda (kWh)",
"One Month Tariff (kWh)": "Tarifa mensual (kWh)",
"Only PDF files are allowed.": "Solo se permiten archivos PDF.",
"Only PDF files are allowed. Leave empty to keep the existing file.": "Solo se permiten archivos PDF. D\u00e9jelo vac\u00edo para conservar el archivo existente.",
"Only for system level users": "Solo para usuarios con privilegios de administrador",
"Only lowercase alphanumeric characters and dashes are allowed": "S\u00f3lo se admiten caracteres alfanum\u00e9ricos en min\u00fasculas y guiones",
"Order No": "N\u00famero pedido",
"Order Numbers": "N\u00famero de pedidos",
"Others": "Otros",
"Overall statement": "Declaraci\u00f3n general",
"Parameter showing Electricity consumption": "Par\u00e1metro que indica el consumo de electricidad",
"Parent Company": "Empresa matriz",
"Parent company and above level access": "Acceso a la empresa matriz y a niveles superiores",
"Partner": "Socio",
"Partner Users for ": "Usuarios asociados para ",
"Partner and above level access": "Acceso de nivel socio y superior",
"Partners": "Socios",
"Partnerships Team": "Equipo de Asociaciones",
"Password": "Contrase\u00f1a",
"Password Changed": "Contrase\u00f1a Modificada",
"Passwords didn't match": "Las contrase\u00f1as no coincid\u00edan.",
"Period/Sum": "Per\u00edodo/Suma",
"Permissions": "Permisos",
"Permissions for ": "permisos para ",
"Personal": "Personal",
"Personal Information": "Informaci\u00f3n personal",
"Please also note to calculate the emission rate from CO2, the 125% method is used, which means that coproduced heat is produced by a given efficiency by 125%.": "Tenga en cuenta tambi\u00e9n que para calcular el \u00edndice de emisiones de CO2 se utiliza el m\u00e9todo del 125%, lo que significa que el calor coproducido se produce con una eficiencia determinada en un 125%.",
"Please authorize us on": "Por favor, autor\u00edcenos en",
"Please enter a valid email and password!": "\u00a1Introduzca una direcci\u00f3n de correo electr\u00f3nico y una contrase\u00f1a v\u00e1lidas!",
"Please enter a valid email!": "Por favor, introduce un email v\u00e1lido!",
"Please enter a valid password!": "\u00a1Introduzca una contrase\u00f1a v\u00e1lida!",
"Please select a file to upload": "Por favor seleccione un archivo para subir",
"Please wait": "Por favor, espere",
"Please wait while security verification loads...": "Por favor, espere mientras se carga la verificaci\u00f3n de seguridad...",
"Price": "Precio",
"Price (cent/kWh)": "Precio (c\u00e9ntimo/kWh)",
"Price (pence/kWh)": "Precio (peniques/kWh)",
"Price (\u00d8re/kWh)": "Precio (\u00d8re/kWh)",
"Price (\u00f8re/kWh)": "Precio (\u00f8re/kWh)",
"Price Price": "Precio",
"Price Share": "Precio por acci\u00f3n",
"Price Type": "Tipo de Precio",
"Price elements": "Elementos del precio",
"Price in (\u00d8re/kWh)": "Precio en (\u00d8re/kWh)",
"Price kWh": "Precio kWh",
"Price type": "Tipo de precio",
"Price type is required": "Se requiere el tipo de precio",
"Prices": "Precios",
"Prices, tariffs, taxes and cost": "Precios, tarifas, impuestos y costes",
"Privacy Policy": "Pol\u00edtica de privacidad",
"Privacy Policy for Fabeke": "Pol\u00edtica de privacidad de Fabeke",
"Procurement": "Adquisici\u00f3n",
"Profile": "Perfil",
"Profile Price": "Perfil Precio",
"Profile Share": "Perfil Compartir",
"Profile Type": "Tipo de perfil",
"Profile kWh": "Perfil kWh",
"Q1": "T1",
"Q2": "T2",
"Q3": "T3",
"Q4": "T4",
"Quantity (kWh)": "Cantidad (kWh)",
"Questions?": "\u00bfPreguntas?",
"Rabat Net Tariff": "Tarifa neta de Rabat",
"Read All Notifications": "Leer todas las notificaciones",
"Read Notification": "Leer notificaci\u00f3n",
"Ready to enhance your offering? Talk to someone from our partnerships team today & start using ": "\u00bfEst\u00e1 preparado para mejorar su oferta? Hable hoy mismo con un miembro de nuestro equipo de socios y empiece a utilizar ",
"Real-time, precise, and automated.": "En tiempo real, precisa y automatizada.",
"Recover Password": "Recuperar contrase\u00f1a",
"Registered successful. Redirecting.": "Registrado con \u00e9xito. Redirigiendo.",
"Remove file": "Borrar archivo",
"Report": "Informe",
"Reports": "Informes",
"Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.": "Solicitar que una empresa que recopila datos personales de un consumidor revele las categor\u00edas y los datos personales espec\u00edficos que ha recopilado sobre los consumidores.",
"Request that a business that sells a consumer's personal data, not sell the consumer's personal data.": "Solicitar que una empresa que vende datos personales de un consumidor, no venda los datos personales del consumidor.",
"Require all devices to sign in again with the new password.": "Solicite a todos los dispositivos que inicien sesi\u00f3n de nuevo con la nueva contrase\u00f1a.",
"Reset Completed": "Reinicio completado",
"Reset Password": "Restablecer contrase\u00f1a",
"Reset Your Password": "Restablecer Contrase\u00f1a",
"Role": "Rol",
"Role Specific Information": "Informaci\u00f3n espec\u00edfica sobre el rol",
"Role key, Alpha numeric and dash only": "Tecla de funci\u00f3n, s\u00f3lo alfanum\u00e9rico y gui\u00f3n",
"Roles": "Roles",
"Save": "Guardar",
"Save All For": "Guardar todo para",
"Save Changes": "Guardar cambios",
"Save Profile": "Guardar perfil",
"Saving. Please wait.": "Guardando. Espere, por favor.",
"Scraper List": "Lista de rascadores",
"Scraper Log": "Tronco rascador",
"Scraper Name": "Nombre del rascador",
"Search": "Buscar",
"See All Notifications": "Ver todas las notificaciones",
"Select": "Seleccionar",
"Select Company": "Seleccionar empresa",
"Select date range": "Seleccionar rango de fechas",
"Select your locality": "Seleccione su localidad",
"Send Link to Email": "Enviar enlace por correo electr\u00f3nico",
"Send the user a notification via email.": "Enviar al usuario una notificaci\u00f3n por correo electr\u00f3nico.",
"Sep": "Sep",
"Sep: Checking": "Sep: Comprobaci\u00f3n de",
"Sep: Get": "Sep: Visite",
"Sep: Update": "Sep: Actualizaci\u00f3n",
"September": "Septiembre",
"Settings": "Ajustes",
"Setup a unique password to protect your account.": "Establece una contrase\u00f1a \u00fanica para proteger tu cuenta.",
"Share": "Compartir",
"Share (%)": "Cuota (%)",
"Show up to": "Mostrar hasta",
"Sign In": "Iniciar sesi\u00f3n",
"Sign Out": "Cerrar sesi\u00f3n",
"Sign Up": "Registrarse",
"Sign in": "Iniciar sesi\u00f3n",
"Sign up": "Registrarse",
"Simple": "Simple",
"Spanish": "Espa\u00f1ol",
"Spot (60%)": "Spot (60%)",
"Spot Premium Price": "Precio de la prima al contado",
"Spot Premium Share": "Prima por acci\u00f3n al contado",
"Spot Price": "Precio al contado",
"Spot Prices": "Precios al contado",
"Spot premium": "Prima al contado",
"Spotpris": "Spotpris",
"Start": "Inicio",
"Start Date": "Fecha de inicio",
"Statement": "Declaraci\u00f3n",
"Statement Export": "Declaraci\u00f3n Exportaci\u00f3n",
"Status": "Estado",
"Still Loading": "Todav\u00eda cargando",
"Street": "Calle",
"Submit": "Enviar",
"Subscription": "Suscripci\u00f3n",
"Subscription Expire At": "La suscripci\u00f3n caduca el",
"Subscription Expired!": "\u00a1Suscripci\u00f3n caducada!",
"Subscription Expiring Soon!": "\u00a1Tu suscripci\u00f3n caduca pronto!",
"Subscription Plan": "Plan de Suscripci\u00f3n",
"Subscription Plan Name": "Nombre del plan de suscripci\u00f3n",
"Subscription Plan added Successfully": "Plan de suscripci\u00f3n a\u00f1adido correctamente",
"Subscription Plans": "Planes de suscripci\u00f3n",
"Subscription key, Alpha numeric and dash only": "Clave de suscripci\u00f3n, s\u00f3lo alfanum\u00e9rica y gui\u00f3n",
"Subscription updated Successfully": "Suscripci\u00f3n actualizada correctamente",
"Sum": "Suma",
"Sum/Average": "Suma/Promedio",
"Support": "Soporte",
"Swedish": "Sueco",
"Switch as": "Cambiar como",
"System": "Sistema",
"System Partners": "Socios del sistema",
"System Price": "Precio del sistema",
"System Roles": "Funciones del sistema",
"System Share": "Cuota del sistema",
"System Tariff": "Tarifa del sistema",
"System Type": "Tipo de sistema",
"System Users": "Usuarios del sistema",
"System kWh": "Sistema kWh",
"TSO - System Subscription": "TSO - Suscripci\u00f3n al sistema",
"Take control of your energy expenses with": "Controle sus gastos energ\u00e9ticos con",
"Tariff": "Tarifa",
"Tax": "Impuestos",
"Taxes (\u00d8re/kWh)": "Impuestos (\u00d8re/kWh)",
"Taxes in (\u00d8re/kWh)": "Impuestos en (\u00d8re/kWh)",
"Tenants": "Clientes",
"Terms & Conditions": "T\u00e9rminos y condiciones",
"Test Climate Report": "Informe sobre el clima de pruebas",
"Test Energy Report": "Informe energ\u00e9tico de la prueba",
"Test Sport Price Report": "Informe de precios de Test Sport",
"Test report": "Informe de la prueba",
"Thank you for registering with us. We're excited to have you on board!": "Gracias por registrarte con nosotros. Estamos encantados de tenerle a bordo!",
"Thanks for signing up!": "Gracias por inscribirse!",
"That is great that you know that.": "Es estupendo que lo sepas.",
"The POC has been updated.": "Se ha actualizado el POC.",
"The cache has been cleared": "Se ha borrado la memoria cach\u00e9",
"The calculations for the CO2 emissions are based on emissions from each power plant above 10MW and where all power plants below 10MW is regarded as one power plant. Furthermore, the calculations are based on production per hour, consumption per hour and exchange per hour.": "Los c\u00e1lculos de las emisiones de CO2 se basan en las emisiones de cada central el\u00e9ctrica de m\u00e1s de 10 MW y en que todas las centrales el\u00e9ctricas de menos de 10 MW se consideran una sola central el\u00e9ctrica. Adem\u00e1s, los c\u00e1lculos se basan en la producci\u00f3n por hora, el consumo por hora y el intercambio por hora.",
"The company already linked.": "La empresa ya est\u00e1 vinculada.",
"The company has been linked.": "La empresa ha sido vinculada.",
"The company has been unlinked.": "La empresa ha sido desvinculada.",
"The data limit has been updated": "Se ha actualizado el l\u00edmite de datos",
"The deal has updated": "El acuerdo ha actualizado",
"The document has been uploaded.": "El documento ha sido cargado.",
"The email has been sent": "\u00a1El email ha sido enviado",
"The file has been exported.": "El archivo se ha exportado.",
"The historical data limit has been added.": "Se ha a\u00f1adido el l\u00edmite de datos hist\u00f3ricos.",
"The mail already exists in the system!": "El correo ya existe en el sistema  ",
"The metering point id from datahub": "El identificador del punto de medici\u00f3n del datahub",
"The module has been updated": "Se ha actualizado el m\u00f3dulo",
"The new POC has been added.": "Se ha a\u00f1adido el nuevo POC.",
"The new deal has added": "El nuevo acuerdo ha a\u00f1adido",
"The new feature has been added": "Se ha a\u00f1adido la nueva funci\u00f3n",
"The new module has been added": "Se ha a\u00f1adido el nuevo m\u00f3dulo",
"The new partner has been added.": "Se ha a\u00f1adido el nuevo socio.",
"The new role has been added.": "Se ha a\u00f1adido la nueva funci\u00f3n.",
"The new user has been added.": "El nuevo usuario ha sido a\u00f1adido.",
"The partner has been updated.": "El socio ha sido actualizado.",
"The password has been reset.": "La contrase\u00f1a se ha restablecido.",
"The password has been updated.": "La contrase\u00f1a ha sido actualizada.",
"The registration is by invitation only.": "La inscripci\u00f3n es solo por invitaci\u00f3n.",
"The role has been updated": "Se ha actualizado el papel",
"The session has been expired.": "La sesi\u00f3n ha expirado.",
"The system is now creating the report, and you can download it shortly by clicking Download.": "El sistema est\u00e1 creando ahora el informe, y podr\u00e1 descargarlo en breve haciendo clic en Descargar.",
"The user already linked.": "El usuario ya est\u00e1 vinculado.",
"The user has been linked.": "El usuario ha sido vinculado.",
"The user has been unlinked.": "El usuario ha sido desvinculado.",
"The user has been updated": "El usuario ha sido actualizado",
"The year cache has been updated": "Se ha actualizado la cach\u00e9 del a\u00f1o",
"There are no documents matching your criteria.": "No hay documentos que coincidan con sus criterios.",
"These terms and conditions outline the rules and regulations for the use of Fabeke's Website, located at https://www.fabeke.com": "Estos t\u00e9rminos y condiciones describen las normas y reglamentos de uso del sitio Web de Fabeke, ubicado en https://www.fabeke.com",
"Third Party Privacy Policies": "Pol\u00edticas de privacidad de terceros",
"Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Fabeke, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.": "Los servidores de anuncios de terceros o redes publicitarias utilizan tecnolog\u00edas como cookies, JavaScript o Web Beacons que se utilizan en sus respectivos anuncios y enlaces que aparecen en Fabeke, que se env\u00edan directamente al navegador de los usuarios. Cuando esto ocurre, reciben autom\u00e1ticamente su direcci\u00f3n IP. Estas tecnolog\u00edas se utilizan para medir la eficacia de sus campa\u00f1as publicitarias y/o para personalizar el contenido publicitario que usted ve en los sitios web que visita.",
"This area is forbidden. Turn back now!": "Esta zona est\u00e1 prohibida. \u00a1Da media vuelta ahora mismo!",
"This is a heads-up, everyone! We've temporarily paused new registrations. But don't worry, we'll open them again shortly. Stay tuned!": "Aviso a todos Hemos suspendido temporalmente las nuevas inscripciones. Pero no os preocup\u00e9is, volveremos a abrirlas en breve. Permanezca atento!",
"Thumbnail View": "Vista de miniatura",
"Time Zone": "Zona horaria",
"Timestamp of last encountered when requesting data from datahub": "Marca de tiempo del \u00faltimo encuentro al solicitar datos al datahub",
"Timezone": "Zona horaria",
"To": "Hasta",
"To complete your registration and activate your account, please confirm your email address by clicking the below:": "Para completar su registro y activar su cuenta, confirme su direcci\u00f3n de correo electr\u00f3nico haciendo clic en el siguiente enlace:",
"To date is required": "Hasta la fecha es necesario",
"To ensure the data is tailored to your local time, we require your": "Para garantizar que los datos se adapten a su hora local, necesitamos su",
"Total Electricity Charge": "Coste total de la electricidad",
"Translation": "Traducci\u00f3n",
"Transmission Grid Tariff": "Tarifa de la red de transporte",
"Type": "Tipo",
"Type of meter. E17 = consumption, E18 = production": "Tipo de contador. E17 = consumo, E18 = producci\u00f3n",
"URL": "URL",
"Under construction": "En contrucci\u00f3n",
"Unit": "Unidad",
"Unknown Error Occurred !": "Se ha producido un error desconocido!",
"Unknown error1 Occurred !": "\u00a1Se ha producido un error desconocido 1!",
"Unlink": "Desvincular",
"Update": "Actualizar",
"Update Roles": "Actualizar roles",
"Update failed": "Fallo en actualizaci\u00f3n",
"Update your Image and other data here.": "Actualice aqu\u00ed su imagen y otros datos.",
"Updated At": "Actualizado en",
"Updating...": "Actualizando...",
"Upload": "Subir",
"Upload Data": "Cargar datos",
"Upload Document Files": "Subir archivos de documentos",
"Upload New Document": "Subir nuevo documento",
"Upload New Document File (Optional)": "Subir nuevo archivo de documento (opcional)",
"Upload PO file": "Subir archivo PO",
"Upload Po file": "Subir archivo Po",
"Uploaded": "Subido",
"Uploading": "Subiendo",
"Uploading...": "Subiendo...",
"Use this page to update the application version. Once you change the version, the client-side application will automatically download and run the latest code from the server.": "Utilice esta p\u00e1gina para actualizar la versi\u00f3n de la aplicaci\u00f3n. Una vez que cambie la versi\u00f3n, la aplicaci\u00f3n cliente descargar\u00e1 y ejecutar\u00e1 autom\u00e1ticamente el c\u00f3digo m\u00e1s reciente desde el servidor.",
"Used:": "Utilizado:",
"User Data": "Datos del usuario",
"User ID is missing": "Falta el ID de usuario",
"Users": "Usuarios",
"Users for the business: ": "Usuarios para la empresa: ",
"Users for the corporate group: ": "Usuarios del grupo empresarial: ",
"V_per_m2": "V_por_m2",
"Validating period": "Per\u00edodo de validaci\u00f3n",
"Validating. Please wait.": "Validando. Por favor, espere.",
"Validity end date": "Fecha final de validez",
"Validity start date": "Fecha de inicio V\u00e1lido",
"Variable/Spot/Nordpool price": "Precio variable/Spot/Nordpool",
"Verification Successful": "Verificaci\u00f3n correcta",
"Verify Password": "Verificar contrase\u00f1a",
"Version": "Versi\u00f3n",
"Version Management": "Gesti\u00f3n de versiones",
"View": "Ver",
"View Mode": "Modo de visualizaci\u00f3n",
"View meter details": "Ver detalles del contador",
"Water": "Agua",
"We are unable to find your email address": "No podemos encontrar su direcci\u00f3n de correo electr\u00f3nico",
"We couldn't find what you searched for": "No hemos encontrado lo que buscaba",
"We employ the use of cookies. By accessing Fabeke, you agreed to use cookies in agreement with the Fabeke's Privacy Policy.": "Utilizamos cookies. Al acceder a Fabeke, aceptas el uso de cookies de acuerdo con la Pol\u00edtica de privacidad de Fabeke.",
"We have updated the reports for last month, and you can download the reports by clicking below": "Hemos actualizado los informes del mes pasado, y puede descargarlos haciendo clic a continuaci\u00f3n",
"Website": "Sitio web",
"Welcome to": "Bienvenido a",
"Welcome to ": "Bienvenido a ",
"What do you know?": "\u00bfT\u00fa qu\u00e9 sabes?",
"Wrong password!": "\u00a1Contrase\u00f1a incorrecta!",
"Year": "A\u00f1o",
"Year Data: Downloading": "Datos del a\u00f1o: Descargar",
"Year Data: Processing": "Datos del a\u00f1o: Tratamiento",
"Year Report - Under development": "Informe anual - En desarrollo",
"Year: Get": "A\u00f1o: Visite",
"Year: Update": "A\u00f1o Actualizaci\u00f3n",
"Yearly": "Anual",
"Years": "A\u00f1os",
"Yes": "S\u00ed",
"Yes I know that.": "S\u00ed, ya lo s\u00e9.",
"You are not authorized to perform this action": "No est\u00e1s autorizado para ejecutar esta acci\u00f3n",
"You can change your password here": "Puede cambiar su contrase\u00f1a aqu\u00ed",
"You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browser's respective websites.": "Puede optar por desactivar las cookies a trav\u00e9s de las opciones individuales de su navegador. Para conocer informaci\u00f3n m\u00e1s detallada sobre la gesti\u00f3n de cookies con navegadores web espec\u00edficos, puede consultarse en los respectivos sitios web de los navegadores.",
"You can continue to use our services now. ": "Ahora puede seguir utilizando nuestros servicios. ",
"You can now use your new password to sign in to your account.": "Ahora puede utilizar su nueva contrase\u00f1a para acceder a su cuenta.",
"You can upload only the PO file. After uploading that file, it takes almost 10 minutes to reflect the changes on the website.": "S\u00f3lo puede cargar el archivo PO. Despu\u00e9s de cargar ese archivo, se tarda casi 10 minutos en reflejar los cambios en el sitio web.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Ha sido invitado por {{partner_name}} para unirse como {{role_name}}. Para continuar, haga clic en Iniciar sesi\u00f3n para acceder al sistema.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "Ha sido invitado por el {{partner_name}} a unirse como {{role_name}}. Para continuar, debe crear una contrase\u00f1a para acceder al sistema.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Ha sido invitado por {{tenant_name}} para unirse como {{role_name}}. Para continuar, haga clic en Iniciar sesi\u00f3n para acceder al sistema.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "Ha sido invitado por el {{tenant_name}} a unirse como {{role_name}}. Para continuar, debe crear una contrase\u00f1a para acceder al sistema.",
"Your Picture": "Tu foto",
"Your account doesn\u2019t exist, please Sign Up": "Su cuenta no existe, por favor Reg\u00edstrese",
"Your login session has been expired. Please log in again": "Su sesi\u00f3n ha expirado. Vuelva a iniciar sesi\u00f3n",
"Your password has been changed": "Tu contrase\u00f1a ha cambiado",
"Your password has been successfully reset.": "Tu contrase\u00f1a se ha restablecido correctamente.",
"Your private file": "Tu archivo privado",
"Your profile has been updated": "Tu perfil ha sido actualizado",
"Your subscription has expired. Renew now to regain access to your account and all premium features.": "Tu suscripci\u00f3n ha caducado. Renu\u00e9vala ahora para volver a tener acceso a tu cuenta y a todas las funciones premium.",
"Your subscription will expire in": "Tu suscripci\u00f3n caducar\u00e1 en",
"Zip Code": "C\u00f3digo postal",
"aggregated": "agregado",
"all": "todo",
"and": "y",
"and Fabeke Tech does not take responsibility for any errors in submitted data and lists": "y Fabeke Tech no se hace responsable de los errores en los datos y listas enviados",
"browse": "explorar",
"cache has been updated": "se ha actualizado la cach\u00e9",
"clicking the link we just emailed you at ": "haciendo clic en el enlace que acabamos de enviarle a ",
"collects your energy data, prices and carbon emissions from all relevant data sources and present your energy consumption, prices, taxes, costs, and carbon emissions in our energy spending platform.": "recopila tus datos energ\u00e9ticos, precios y emisiones de carbono de todas las fuentes de datos relevantes y presenta tu consumo energ\u00e9tico, precios, impuestos, costes y emisiones de carbono en nuestra plataforma de gasto energ\u00e9tico.",
"comprehensive data and insights": "datos e informaci\u00f3n exhaustivos",
"contact us": "cont\u00e1ctenos",
"converts data into your language and local time zone": "convierte los datos a su idioma y zona horaria local",
"country, timezone and corporate group": "pa\u00eds, zona horaria y grupo empresarial",
"does not take responsibility for any errors in submitted data and lists": "no se hace responsable de los errores que puedan contener los datos y listas enviados.",
"export": "exportar",
"export to CSV": "exportar a CSV",
"export to Excel": "exportar a Excel",
"export to PDF": "exportar a PDF",
"files": "archivos",
"for any queries.": "para cualquier consulta.",
"g CO\u2082/kW": "g CO\u2082/kW",
"g CO\u2082e/kW": "g CO\u2082e/kW",
"gives you": "te da",
"https://www.example.com": "https://www.example.com",
"into your energy usage, costs, and carbon footprint.": "en su consumo de energ\u00eda, costes y huella de carbono.",
"kWh": "kWh",
"measuring the Carbon dioxide Consumption. potential difference across a surface area, we use the unit carbon dioxide per square meter (Co2/m2)": "medir el Consumo de di\u00f3xido de carbono. diferencia de potencial a trav\u00e9s de una superficie, utilizamos la unidad di\u00f3xido de carbono por metro cuadrado (Co2/m2)",
"measuring the electrical potential difference across a surface area, we use the unit volts per square meter (V/m2)": "para medir la diferencia de potencial el\u00e9ctrico en una superficie, se utiliza la unidad voltios por metro cuadrado (V/m2)",
"or": "o",
"page": "p\u00e1gina",
"q": "q",
"real-time, accurate insights": "informaci\u00f3n precisa y en tiempo real",
"ubscription Expire A": "Suscripci\u00f3n caducada A",
"v": "vs"
},
"plural": "(n != 1)"
}